import type { FaireProductEntity } from "../../entity_types/product";

export const p_f4apvqfc4s: FaireProductEntity = {
  token: "p_f4apvqfc4s",
  type: "product",
  name: "Classic Grape",
  brandToken: "b_2ncsmapy03",
  brandName: "Olipop",
  imageUrl:
    "https://cdn.faire.com/fastly/e202fcb8c63ba238fa7547a53a08f6fbc73273c8ebee0a4a8dfd436c29e80aaf.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a1892511bc941835be808f5b6280c2e79361b53f1252133b21de0825244a667c.png",
    "https://cdn.faire.com/fastly/aef5f1a97ce88888e1ea3e93d9ba288ddca6736fdc1331ebff7fb7161cb3adfe.png",
    "https://cdn.faire.com/fastly/6b761706a6762dd3b753a2f7c8eba265079008a3fdb999da5352cf3fc214c025.png",
    "https://cdn.faire.com/fastly/1055d47b5f6324bcbfa685f5c0ae10c5c505c755c9452689d7d19d1d3073ead2.png",
  ],
  priceDollars: 28.99,
  description:
    "We’re giving grape an upgrade. Made from real concord grape juice with a hint of lime to create the perfect blend of sweet and tart, our Classic Grape is the nostalgic flavor you know and love—all grown up.\n\nWholesale cost offers landed cost of $2.42 per unit, which provides a 40% gross margin to the retailer at $3.99 MSRP.",
  tags: [],
  msrpDollars: 57.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T17:24:09.207Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
